function roundTo(decimals, f = Math.round) {
    return function round(value) {
        let result = Number(value + `e+${decimals}`);
        result = f(result);
        result = Number(result + `e-${decimals}`);
        return result;
    };
}
/**
 * Gets the number of decimals for a given range to be formatted with the 'BEST' format.
 *
 * @return A number greater than or equal to 0.
 */
function getBestPrecision(range) {
    const rangeLength = range[1] - range[0];
    if (rangeLength <= 0 || rangeLength >= 10) {
        // log(0) is -Infinity and log(-numbers) is NaN
        // ranges 10 or greater get 0 decimal places.
        return 0;
    }
    else {
        // ranges smaller than 10 get 1 more decimal place than the range itself has
        return Math.ceil(-(Math.log(rangeLength) / Math.log(10))) + 1;
    }
}
export function createStepsForNumericRange(formatter, range) {
    // NOTE: might need to snap the result of this into safe ranges (and just accept a range size param?)
    const rangeSize = range[1] - range[0];
    let step = rangeSize / 100;
    let stepLarge = rangeSize / 10;
    if (formatter.getFormatName() === 'BEST') {
        const decimals = getBestPrecision(range);
        if (rangeSize > 100) {
            // Math.floor is used here to give the most granularity
            // This is because we don't care if 100 presses of KeyRight/Left spans the entire range here. The
            // individual presses and how much precision they have is more important.
            step = roundTo(decimals, Math.floor)(step);
        }
        else if (rangeSize === 0) {
            step = 0;
        }
        else {
            // For rangeSizes below 100, just use the precision size.
            step = Math.max(step, 10 ** (-1 * decimals));
        }
        // Math.ceil is used here because we always want 10 hits of PageUp/PageDown to span the entire range.
        stepLarge = roundTo(decimals, Math.ceil)(stepLarge);
    }
    // NOTE: stepMedium isn't needed because Slider will default to using step * 2 for it.
    return [step, /* stepMedium */ undefined, stepLarge];
}
